export default {"src":"/_next/static/media/other.4734656b.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};